<div class="header-container">
  <div class="titre-modale">
    @if (procedureTitre) {
      <span>
        Visualisation du logigramme de la procédure : <b>{{ procedureTitre }}</b>
      </span>
    }
  </div>
  <div class="buttons">
    <button mat-flat-button mat-dialog-close title="Fermer la modale" class="close-modale-button"  (click)="sendLogigramme()">
      <div class="wrapper">
        <mat-icon >close</mat-icon>
      </div>
    </button>
  </div>

</div>


<div style="height: 100%">
  <app-jointjs-plus [logigramme]="logigramme" [readOnly]="true" (closeDialogEvent)="closeDialog($event)"></app-jointjs-plus>
</div>

<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close (click)="sendLogigramme()" title="Fermer la modale">Quitter</button>
</mat-dialog-actions>


